/** CastingTime::IDS (includes/additions.php), shared by the spell gate and ability spender. */
export const CASTING_TIME_AP: Readonly<Record<string, number | 'r'>> = {
  '3ap': 3, '2ap': 2, '1ap': 1, reaction: 'r',
  one_minute: 3, ten_minutes: 3, one_hour: 3, eight_hours: 3, twelve_hours: 3, twenty_four_hours: 3,
};

/** The authored action cost shared by the control gate and the action spender. Null names unsupported casting data. */
export function abilityActionCost(type: string, castingTime: unknown): number | 'r' | null {
  let cost: number | 'r';
  if (castingTime != null) {
    const time = String(castingTime), mapped = CASTING_TIME_AP[time];
    if (typeof mapped === 'number' || mapped === 'r') cost = mapped;
    else {
      const match = /^(\d+)ap$/.exec(time);
      cost = match ? Number(match[1]) : NaN;
      if (!Number.isSafeInteger(cost)) return null;
    }
  } else {
    cost = type === 'full_ability' ? 3 : type === 'ability' ? 2
      : ['quick_ability', 'potion', 'coating', 'food', 'drink', 'elixir'].includes(type) ? 1
        : ['free_ability', 'sanguine'].includes(type) ? 0 : 1;
  }
  if (cost === 'r' || type === 'reaction_ability' || type === 'opportunity_attack_ability') return 'r';
  return ['trap_ability', 'free_ability', 'attack_ability'].includes(type) ? 0 : cost;
}
